import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/primary/quotes.png")